import { patchAssistant } from './phase1StreamPatch'

function hasArtifact(run) {
  return (run?.blocks ?? []).some((block) => block?.type === 'artifact_card')
}

/**
 * A turn can fail *after* its answer has streamed — a runtime raising between
 * the last chunk and `done`. Overwriting the text then destroys a complete,
 * correct reply the user is already reading, so whatever arrived is kept and
 * the failure is reported alongside it rather than in its place.
 */
export function patchPhase1Error(ctx, error, run = null) {
  const message = error?.message ?? 'Connection lost.'
  if (hasArtifact(run)) {
    return patchAssistant(ctx, {
      text: run.text || '',
      blocks: run.blocks,
      activity: run.activity,
      workStatus: run.workStatus,
      publicTimeline: run.publicTimeline,
      citations: run.citations,
      memoryIds: run.memoryIds,
      demoStreamActive: false,
      thoughtSummary: 'Document ready',
      phase1Error: true,
      phase1ErrorMessage: message,
    })
  }
  const streamed = run?.text ?? ''
  patchAssistant(ctx, {
    text: streamed || `Could not get a reply.\n\n${message}`,
    blocks: run?.blocks ?? [],
    activity: run?.activity ?? [],
    workStatus: run?.workStatus ?? null,
    publicTimeline: run?.publicTimeline ?? [],
    citations: run?.citations ?? [],
    memoryIds: run?.memoryIds ?? [],
    demoStreamActive: false,
    thoughtSummary: streamed ? 'Answer incomplete' : 'Stream failed',
    phase1Error: true,
    // Only when there is an answer to sit beside; otherwise the text above
    // already carries the failure and repeating it reads as two errors.
    phase1ErrorMessage: streamed ? message : null,
  })
}

export function patchPhase1Interrupted(ctx, run) {
  patchAssistant(ctx, {
    text: run?.text || 'Response interrupted.',
    blocks: run?.blocks ?? [],
    activity: run?.activity ?? [],
    workStatus: run?.workStatus ?? null,
    publicTimeline: run?.publicTimeline ?? [],
    citations: run?.citations ?? [],
    memoryIds: run?.memoryIds ?? [],
    demoStreamActive: false,
    thoughtSummary: 'Response interrupted',
    phase1Interrupted: true,
  })
}
